<template>
  <div id="store-index-page">
    <main class="content">
      <b-overlay :show="branchIsLoadingOverlay" rounded="sm">
        <div style="min-height: 470px" class="d-flex overflow-hidden">
          <template v-if="specificBranch != null">
            <div
              class="banner-content"
              :style="{
                backgroundImage: `url( ${
                  specificBranch.use_branch_image == 0 ? specificBranch.web_store_banner : (
                  specificBranch.banner_images.length
                    ? specificBranch.banner_images[0]
                    : specificBranch.branch_image
                  )
                })`,
              }"
            >
              <div class="container pt-60">
                <div class="logo-wrapper">
                  <img :src="specificBranch.brand_image" alt width="100%" />
                </div>
                <div class="store-desc">
                  <div class="store-desc-item">
                    <div class="store-desc-item-title">
                      {{ specificBranch.brand_name }}
                    </div>
                    <p class="store-desc-item-subtext">
                      {{
                        specificBranch.brand_categories | formatCategoryNames
                      }}
                    </p>
                    <div class="store-desc-item-desc">
                      <span>{{ distance }} km</span>
                      <div class="vertical-separator"></div>
                      <template v-if="specificBranch.is_open">
                        <span class="clrGreen">Open</span>
                      </template>
                      <template v-else>
                        <span class="clrRed">Closed</span>
                      </template>
                    </div>
                    <div>
                      <p class="blck text-capitalize">
                        {{ specificBranch.street }}, {{ specificBranch.city }},
                        {{ specificBranch.province }}
                      </p>
                    </div>

                    <span
                      class="text-main cpointer fw-bold"
                      @click="showStoreModal"
                      >Store Info</span
                    >
                    <b-modal
                      id="storeInfo"
                      ref="storeInfo"
                      hide-footer
                      @shown="refreshMap"
                    >
                      <template v-slot:modal-header>
                        <GmapMap
                          :center="{
                            lat: specificBranch.latitude,
                            lng: specificBranch.longitude,
                          }"
                          :options="{
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: false,
                            disableDefaultUi: false,
                          }"
                          :zoom="zoom"
                          map-type-id="terrain"
                          :style="currentStyle"
                        >
                          <gmap-info-window
                            :opened="true"
                            :position="{
                              lat: specificBranch.latitude,
                              lng: specificBranch.longitude,
                            }"
                            :options="{
                              pixelOffset: {
                                width: 0,
                                height: -35,
                              },
                            }"
                          >
                            <p class="lead">
                              {{ specificBranch.brand_name }} ({{
                                specificBranch.name
                              }})
                            </p>
                          </gmap-info-window>
                          <GmapMarker
                            :position="{
                              lat: specificBranch.latitude,
                              lng: specificBranch.longitude,
                            }"
                            :icon="{
                              url: require('@/assets/images/marker.svg'),
                            }"
                          />
                        </GmapMap>
                        <img
                          src="@/assets/images/ic-circle-close.svg"
                          width="40px"
                          class="close-btn"
                          data-dismiss="modal"
                          style="
                            cursor: pointer;
                            padding: 5px;
                            position: absolute;
                            right: 15px;
                          "
                          @click="closeModal('storeInfo')"
                          alt="Close"
                        />
                      </template>
                      <template v-slot:default>
                        <div class="store-info">
                          <h2>Store Info</h2>
                          <div class="store-info-details">
                            <div class="mr-3">
                              <StoreLocationIcon
                                :fill="webDesign && webDesign.design ? webDesign.design.main_color : '#2F3941'"
                                :stroke="webDesign && webDesign.design ? webDesign.design.button_text_color : '#ffffff'"
                              />
                            </div>
                            <div
                              class="store-info-details-text text-capitalize"
                            >
                              {{ specificBranch.street }},
                              {{ specificBranch.city }},
                              {{ specificBranch.province }}
                            </div>
                          </div>
                          <div class="store-info-details">
                            <div class="contact-number-icon-container mr-2">
                                <StoreTelNo
                                  :fill="webDesign && webDesign.design ? webDesign.design.main_color : '#2F3941'"
                                  :stroke="webDesign && webDesign.design ? webDesign.design.button_text_color : '#ffffff'"
                                />
                            </div>
                            <div class="store-info-details-text">
                              {{ specificBranch.branch_mobile }}
                              <span
                                v-if="specificBranch.branch_landline != null"
                                >/</span
                              >
                              {{ specificBranch.branch_landline }}
                            </div>
                          </div>
                        </div>
                      </template>
                    </b-modal>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </b-overlay>
      <div id="products-navigation">
        <b-container class="px-0">
          <b-row class="products-navigation-items">
            <b-col lg="8">
              <div
                id="nav-for-category"
                :style="[
                  'border-bottom: 1px solid #d8dcde;',
                  { top: getNavCategoryTopPosition() },
                ]"
              >
                <b-container no-gutter class="bg-white py-3" id="navigation">
                  <b-button
                    v-for="(
                      category, index
                    ) in mainCategories"
                    :key="`main-categories-${index}`"
                    class="mr-3"
                    :class="['pill-category border-0 px-3 mb-2']"
                    pill
                    tag="a"
                    :href="`#product-category-${category.id}`"
                    @click.prevent.self="scrollTo(category.id)"
                    :style="getStyles"
                  >
                    {{ category.name }}
                  </b-button>
                  <b-dropdown
                    id="other-categories"
                    v-show="otherCategories.length > 0"
                    text="Others"
                    toggle-class="pill-category rounded-pill border-0 pl-3 other-categories-toggle position-relative"
                    menu-class="border-0 other-categories-dropdown"
                    :style="getStyles"
                  >
                    <b-dropdown-item
                      v-for="(
                        category, index
                      ) in otherCategories"
                      :key="`other-categories-${index}`"
                      :href="`#product-category-${category.id}`"
                      link-class="other-categories-link py-2"
                      @click.prevent.self="scrollTo(category.id)"
                      :style="getStyles"
                    >
                      {{ category.name }}
                    </b-dropdown-item>
                  </b-dropdown>
                </b-container>
              </div>
            </b-col>
            <b-col lg="4" class="pb-4 pb-lg-0">
              <b-container id="search-products-container">
                <b-input-group class="mt-3">
                  <template #prepend>
                    <b-input-group-text>
                      <i class="bi bi-search" aria-hidden="true"></i>
                    </b-input-group-text>
                  </template>
                  <b-input
                    v-model="searchKey"
                    placeholder="Search product"
                  ></b-input>
                  <template #append>
                    <b-input-group-text>
                      <i
                        v-if="searchKey"
                        class="bi bi-x-circle-fill text-muted cursor-pointer"
                        @click="resetProducts"
                        aria-hidden="true"
                      >
                      </i>
                    </b-input-group-text>
                  </template>
                </b-input-group>
              </b-container>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div rounded="sm">
        <div
          class="container store-product mb-50 text-capitalize"
          v-for="(category, index) in productCategories"
          :key="index"
        >
          <div class="section" :id="`product-category-${category.id}`">
            {{ category.name }}
          </div>

          <div class="row">
            <template v-for="(product, index) in products">
              <div
                v-if="product.category_id == category.id"
                :key="index"
                class="col-md-6 col-lg-4"
              >
                <div
                  class="store-product-item"
                  :class="[
                    {
                      disabled: !specificBranch.is_open || isTemporaryClosed,
                    },
                  ]"
                  @click="
                    showModal(
                      product.uuid,
                      specificBranch.is_open && !isTemporaryClosed
                    )
                  "
                  :key="index"
                >
                  <div class="row">
                    <div class="col-7 pr-0">
                      <div class="product-contents">
                        <div class="product-name">
                          {{ product.name }}
                        </div>
                        <div class="product-description">
                          {{ product.description }}
                        </div>
                        <template
                          v-if="
                            product.inventory != undefined &&
                            product.inventory.on_sale &&
                            $moment().isBetween(
                              product.inventory.on_sale_from, 
                              product.inventory.on_sale_to
                            ) 
                          "
                        >
                          <span class="original-price">
                            &#8369; {{ product.inventory.regular_price }}
                          </span>
                          <span
                            class="sale-price ml-2"
                            :style="{
                              color: webDesign.design.main_color + '!important',
                            }"
                          >
                            &#8369;
                            {{
                              product.inventory.sale_price
                                .toFixed(2)
                                .toLocaleString()
                            }}
                          </span>
                        </template>
                        <template v-else>
                          <span
                            class="sale-price"
                            :style="{
                              color: webDesign.design.main_color + '!important',
                            }"
                          >
                            &#8369; {{ product.price }}
                          </span>
                        </template>
                      </div>
                    </div>
                    <div class="col-5 pl-0">
                      <div
                        class="product-image"
                        :style="{
                          backgroundImage: `url(${get(product, 'images[0].image_name')})`,
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <template v-if="!products.length && !estoreIsLoading">
          <div
            class="h3 text-center"
            :class="[{ 'text-primary': !webDesign || !webDesign.design }]"
            :style="{
              color:
                webDesign && webDesign.design
                  ? webDesign.design.main_color
                  : null,
            }"
          >
            Sorry, no products found.
          </div>
        </template>
        <JumpingDotsLoader v-if="estoreIsLoading || showLoadingMoreProducts" :fill="webDesign.design.main_color" />
      </div>
      <!-- Product Modal -->
      <b-modal
        class="fade"
        id="product_details"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref="productModal"
        hide-backdrop
        no-close-on-esc
        no-close-on-backdrop
        size="sm"
        @show="initAddOns"
        centered
        scrollable
      >
        <template v-slot:modal-header>
          <div class="banner-content">
            <div
              :class="[
                'p-2 product-modal-close position-absolute',
                {
                  'product-title-if-not-visible bg-white d-inline-flex w-100 align-items-center justify-content-between':
                    isTitleVisible,
                },
              ]"
            >
              <h4 style="word-break: break-all" v-if="isTitleVisible">
                {{ specificProduct.product_details.name }}
              </h4>
              <img
                src="@/assets/images/ic-circle-close.svg"
                width="40px"
                class="close-btn"
                data-dismiss="modal"
                style="cursor: pointer; float: right; padding: 5px"
                @click="closeModal('productModal')"
                alt="Close"
              />
            </div>
            <div id="product-carousel" class="position-relative" :style="getStyles">
              <VueSlickCarousel
                :arrows="false"
                :dots="true"
                dotsClass="slick-dots d-flex position-absolute"
                :autoplay="true"
                :infinite="false"
                :adaptiveHeight="true"
              >
                <div
                  v-for="(prodImg, prodImgIndex) in specificProduct.product_details.images"
                  :key="`product_image_${prodImgIndex}`"
                >
                  <img :src="prodImg.image_name" :alt="`product_image_${prodImgIndex}`" width="100%">
                </div>
              </VueSlickCarousel>
            </div>
          </div>
        </template>
        <template v-slot:default>
          <div class="food-desc">
            <h2
              class="mb-10"
              style="word-break: break-all"
              id="productNameDetails"
            >
              {{ specificProduct.product_details.name }}
            </h2>
            <p style="word-break: break-word; white-space: pre-line">
              {{ specificProduct.product_details.description }}
            </p>
          </div>
          <template v-if="specificProduct.product_details.type == 'simple'">
            <div class="food-choices"></div>
          </template>
          <template v-else>
            <div class="divider"></div>
            <div
              class="food-choices"
              v-for="(attribute, index) in formattedAttributes[
                specificProduct.product_details.name.toLowerCase()
              ]"
              :key="index"
            >
              <div>
                <h2 class="d-inline-block mr-2">
                  {{ `Choose ${attribute.name}` }}
                </h2>
                <span class="invalid-feedback d-inline">
                  {{ invalidFeedback(attribute.name.toLowerCase()) }}
                </span>
              </div>
              <b-form-group>
                <b-form-radio
                  v-for="(variation, index) in attribute.variations"
                  :key="index"
                  :name="attribute.name"
                  :value="variation.hash"
                  @change="
                    selectVariation(
                      specificProduct.product_details.name.toLowerCase(),
                      attribute.name.toLowerCase(),
                      variation.hash
                    )
                  "
                  >{{ variation.name }}</b-form-radio
                >
              </b-form-group>
            </div>
          </template>
          <!-- Start: Add-Ons -->
          <template
            v-if="specificProduct.product_details.add_on_category.length > 0"
          >
            <div class="divider"></div>
            <div class="food-choices">
              <b-form-group
                v-for="(addon, index) in specificProduct.product_details
                  .add_on_category"
                :key="`addOn_category${index}`"
              >
                <h2 class="mb-2">
                  {{
                    `${addon.name} (${addOns[`${addon.id}`].length}/${
                      addon.limit
                    })`
                  }}
                </h2>
                <b-form-checkbox-group
                  stacked
                  v-model="addOns[`${addon.id}`]"
                  class="addons-checkbox-group"
                >
                  <b-form-checkbox
                    v-for="(item, itemIndex) in addon.add_ons"
                    :key="`addOn_item${itemIndex}`"
                    :value="`${addon.id}|${item.uuid}`"
                    @change="updateSelectedAddOns(addon.limit, addon.id)"
                  >
                    <span>
                      {{ item.name }}
                    </span>
                    <small v-if="!item.is_free">{{
                      `+ P${item.currency
                        .toLowerCase()
                        .substring(1)} ${item.price.toFixed(2)}`
                    }}</small>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </template>
          <!-- End: Add-Ons -->
          <template
          >
            <div class="divider"></div>
            <div class="food-choices">
              <b-form-group>
                <h2 class="mb-2">
                Add Notes
                </h2>
                <b-form-textarea
                  id="textarea"
                  v-model="remarks"
                  placeholder="Include your additional notes or requests here"
                  rows="3"
                  maxlength="149"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </div>
          </template>
        </template>
        <template v-slot:modal-footer>
          <div
            id="modal-footer"
            class="
              d-flex
              flex-column flex-md-row
              w-100
              align-items-center
              justify-content-between
            "
          >
            <div class="increase-item d-inline-flex align-items-center">
              <button
                class="btn"
                @click="subtractQuantity()"
                :disabled="quantity < 2"
              >
                <FillableMinusIcon
                  :fill-color="
                    webDesign && webDesign.design
                      ? webDesign.design.main_color
                      : '#ff8a00'
                  "
                  :button-text-color="
                    webDesign && webDesign.design
                      ? webDesign.design.button_text_color
                      : '#FFFFFF'
                  "
                />
              </button>
              <input
                type="number"
                class="item-count"
                v-model="quantity"
                min="1"
                disabled
              />
              <button
                class="btn"
                @click="addQuantity()"
                :disabled="productIsUnavailable || outOfStock"
              >
                <FillablePlusIcon
                  :fill-color="
                    webDesign && webDesign.design
                      ? webDesign.design.main_color
                      : '#ff8a00'
                  "
                  :button-text-color="
                    webDesign && webDesign.design
                      ? webDesign.design.button_text_color
                      : '#FFFFFF'
                  "
                />
              </button>
            </div>
            <div
              class="
                d-flex
                flex-column flex-md-row
                align-items-center
                mt-3 mt-md-0
              "
            >
              <b-button
                v-if="!outOfStock"
                type="button"
                class="
                  btn btn-core-shallow
                  w-10
                  mb-3 mb-md-0
                  mr-2
                  border-0
                  px-4
                "
                @click="addToCart()"
                :disabled="
                  estoreIsLoading || productIsUnavailable || isOrdersAllowed || outOfStock
                "
                :style="{
                  background:
                    webDesign && webDesign.design
                      ? webDesign.design.main_color
                      : '#ff8a00',
                  color:
                    webDesign && webDesign.design
                      ? webDesign.design.button_text_color
                      : null,
                }"
                pill
              >
                <template v-if="!productIsUnavailable"> ADD TO CART </template>
                <template v-else> NOT AVAILABLE </template>
              </b-button>
              <b-button
                v-else
                type="button"
                class="
                  btn btn-core-shallow
                  w-10
                  mb-3 mb-md-0
                  mr-2
                  border-0
                  px-4
                "
                :disabled="
                  estoreIsLoading || productIsUnavailable || isOrdersAllowed || outOfStock
                "
                :style="{
                  background: '#494949',
                  color:
                    webDesign && webDesign.design
                      ? webDesign.design.button_text_color
                      : null,
                }"
                pill
              >
                OUT OF STOCK
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>
      <!-- Stocks Modal -->
      <b-modal ref="stocksModal" hide-footer>
        <div
          class="modal-body aCenter"
          v-if="estoreErrors && estoreErrors.errors"
        >
          <img src="@/assets/images/info.svg" class="mt-10 mb-4" alt="Information" />
          <p>{{ estoreErrors.errors.message }}</p>
        </div>
        <div class="modal-body aCenter" v-else>
          <img src="@/assets/images/info.svg" class="mt-10" alt="Information" />
          <p>Quantity should not be more than the current stock.</p>
          <p>
            Current Stock:
            <strong>{{ stock }}</strong>
          </p>
        </div>
      </b-modal>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import $ from "jquery";
import FillablePlusIcon from "@/components/fillable-plus-icon";
import FillableMinusIcon from "@/components/fillable-minus-icon";
import _ from "lodash";
import VueSlickCarousel from "vue-slick-carousel";
import StoreLocationIcon from "@/components/store/LocationIcon";
import StoreTelNo from "@/components/store/StoreTelNo";
import JumpingDotsLoader from "@/components/common/JumpingDotsLoader";

export default {
  data() {
    return {
      get: _.get,
      mainCategories: [],
      otherCategories: [],
      showLoadingMoreProducts: false,
      page: 1,
      quantity: 1,
      maxOrder: 1,
      simpleSelected: false,
      status: [],
      formattedCategories: null,
      formattedSpecificProduct: null,
      formattedAttributes: {},
      selectedVariations: {},
      variationProductTotal: "",
      stock: null,
      zoom: 19,
      currentStyle: { width: "100%", height: "200px" },
      currentRoute: this.$router.currentRoute.path,
      productIsUnavailable: false,
      addOns: [],
      dateToday: this.$moment(),
      unlimitedStock: false,
      categoryIdToSearch: null,
      isTitleVisible: false,
      remarks: "",
      searchKey: "",
      distance: 0,
      outOfStock: false
    };
  },
  components: { FillablePlusIcon, FillableMinusIcon, VueSlickCarousel, StoreLocationIcon, StoreTelNo, JumpingDotsLoader },
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
      authErrors: (state) => state.errors,
      authIsLoading: (state) => state.loading,
    }),
    ...mapState("merchant", {
      subdomain: (state) => state.subdomain,
      customerPortalToken: (state) => state.customerPortalToken,
      merchantIsLoading: (state) => state.loading,
      merchantErrors: (state) => state.errors,
    }),
    ...mapState("branch", {
      branches: (state) => state.branches,
      branchesNearby: (state) => state.branchesNearby,
      branchesErrors: (state) => state.errors,
      branchIsLoadingOverlay: (state) => state.loadingOverlay,
      branchIsLoading: (state) => state.loading,
      specificBranch: (state) => state.specificBranch,
      coordinates: (state) => state.coordinates,
    }),
    ...mapState("estore", {
      products: (state) => state.products,
      estoreIsLoadingOverlay: (state) => state.loadingOverlay,
      estoreIsLoading: (state) => state.loading,
      estoreErrors: (state) => state.errors,
      specificProduct: (state) => state.specificProduct,
      cart: (state) => state.cart,
      categories: (state) => state.categories,
      publicCategories: (state) => state.publicCategories,
      webDesign: (state) => state.webDesign,
      nextPage: (state) => state.nextPage,
      prevPage: (state) => state.prevPage,
      maxPage: (state) => state.maxPage,
    }),
    ...mapGetters({
      loggedIn: "auth/loggedIn",
      firstBranchNearby: "branch/firstBranchNearby",
      cartUuid: "estore/cartUuid",
      isMobile: "isMobile/isMobile"
    }),
    productCategories() {
      const productCategoryIds = this.products.map(({ category_id }) => category_id);

      return this.publicCategories.filter(({ id }) => productCategoryIds.includes(id));
    },
    addOnsCharges() {
      // Computed Property for Add Ons Total Charges
      let total = 0;
      const addOns = this.specificProduct.product_details.add_on_category;
      Object.keys(this.addOns).forEach((id) => {
        this.addOns[`${id}`].forEach((item) => {
          const addOnData = addOns
            .find((category) => category.id === Number(id))
            .add_ons.find((addon) => addon.uuid === item.split("|")[1]);
          total = total += addOnData.is_free ? 0 : addOnData.price;
        });
      });
      return total * this.quantity;
    },
    getStyles() {
      return {
        "--color":
          this.webDesign !== null && this.webDesign.design !== null
            ? this.webDesign.design.main_color
            : "#ff8a00",
        "--button-text-color":
          this.webDesign && this.webDesign.design
            ? this.webDesign.design.button_text_color
            : "#fff",
      };
    },
    isTemporaryClosed: {
      get() {
        const todayHour = this.specificBranch
          ? this.specificBranch.store_hours.find(
              (store_hour) =>
                store_hour.day ===
                this.$moment(this.dateToday).format("dddd").toLowerCase()
            )
          : {};
        return "temporary_closed" in todayHour && todayHour.temporary_closed;
      },
    },
    isOrdersAllowed: {
      get() {
        return "orders_allowable" in this.specificBranch
          ? !this.specificBranch.orders_allowable
          : true;
      },
    }
  },
  async created() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $(window).scroll(function () {
      const position = $(this).scrollTop();
      $(".section").each(function () {
        const target = eval($(this).offset().top - 420);
        const id = $(this).attr("id");
        const otherCategoriesDropdown =
          document.getElementById("other-categories");
        const pillIds = [...document.querySelectorAll(".pill-category")].map(
          (pill) => pill.hash
        );

        if (position >= target) {
          $("#navigation > a").removeClass("active");
          $(`#navigation > a[href='#${id}']`).addClass("active");
          
          if (otherCategoriesDropdown) {
            $(`.dropdown-toggle.other-categories-toggle`).removeClass("active");
            $(".other-categories-dropdown .other-categories-link").removeClass(
              "active"
            );
          }

          if (otherCategoriesDropdown && !pillIds.includes(`#${id}`)) {
            $(`.dropdown-toggle.other-categories-toggle`).addClass("active");
            $(
              `.other-categories-dropdown .other-categories-link[href='#${id}']`
            ).addClass("active");
          }
        }
      });
    });
    this.handleSearchKeyChange = _.debounce(async () => {
      $("#navigation > a").removeClass("active");
      $(`.dropdown-toggle.other-categories-toggle`).removeClass("active");
      $(".other-categories-dropdown .other-categories-link").removeClass(
        "active"
      );

      await this.loadProducts();

      if (this.searchKey && this.products.length) {
        const categoryId = _.get(this.products, "[0].category_id");
        const otherCategory = this.otherCategories.find(
          ({ id }) => id === categoryId
        );

        if (otherCategory) {
          $(`.dropdown-toggle.other-categories-toggle`).addClass("active");
          $(
            `.other-categories-dropdown .other-categories-link[href='#product-category${categoryId}']`
          ).addClass("active");
        } else $(`#navigation > a[href='#product-category-${categoryId}']`).addClass("active");
      }
    }, 1000);

    this.$store.commit("estore/resetProducts");
    await this.getPublicCategories();
    await this.getSpecificBranch();

    if (!this.searchKey && !this.products.length) {
      this.$router.push({ name: "Home" }); 
      return;
    }

    if (this.productUuid)
      this.showModal(
        this.productUuid,
        this.specificBranch.is_open && !this.isTemporaryClosed
      );

    this.distance = require("gps-latlon")(
      this.specificBranch.latitude,
      this.specificBranch.longitude,
      this.coordinates.lat,
      this.coordinates.long,
      "km"
    ).toFixed(1);
  },
  methods: {
    async getPublicCategories() {
      let ids = this.id.split("&");

      let publicCategoriesRequest = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          branch_uuid: ids[0],
          brand_uuid: ids[1]
        },
      };

      await this.$store.dispatch(
        "estore/getPublicCategories",
        publicCategoriesRequest
      );
      
      const mainCategoriesLength = this.calculateMainCategoriesLength();

      this.initializeMainCategories(mainCategoriesLength);
      this.initializeOtherCategories(mainCategoriesLength);
    },
    calculateMainCategoriesLength() {
      let mainCategoriesLength = 1;
      
      if (this.isMobile) {
        let charactersLength = parseInt($(window).width() - 
          $('#nav-for-category').width() - $('#other-categories').width());

        for (let category of this.publicCategories) {
          charactersLength -= category.name.length;

          if (charactersLength <= 0) break;

          mainCategoriesLength++;
        }
      } else {
        mainCategoriesLength = 5;
      }

      return mainCategoriesLength;
    },
    initializeMainCategories(length) {
      this.mainCategories = this.publicCategories.length > length ?
        this.publicCategories.slice(0, length) :
        this.publicCategories;
    },
    initializeOtherCategories(length) {
      const categories = _.cloneDeep(this.publicCategories);
      this.otherCategories = categories.length > length ? categories.splice(length) : [];
    },
    async getProducts() {
      let ids = this.id.split("&");
      if (this.loggedIn && this.customerPortalToken != null) {
        let request = {
          header: {
            Authorization: this.token,
            "X-Merchant-Token": this.customerPortalToken,
          },
          payload: {
            branch_uuid: ids[0],
            brand_uuid: ids[1],
            product_name: this.searchKey,
          },
          page: this.page,
        };
        await this.$store.dispatch("estore/getProducts", request);
      }
    },
    async getPublicProducts() {
      let ids = this.id.split("&");
      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          branch_uuid: ids[0],
          brand_uuid: ids[1],
          product_name: this.searchKey,
        },
        page: this.page,
      };
      await this.$store.dispatch("estore/getPublicProducts", request);
    },
    async getSpecificBranch() {
      let ids = this.id.split("&");

      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        is_public: !this.loggedIn,
        payload: {
          branch_uuid: ids[0],
        },
      };

      if (this.loggedIn) {
        request.header["Authorization"] = this.token;
      }

      await this.$store
        .dispatch("branch/getSpecificBranch", request)
        .then(async () => {
          if (this.loggedIn) {
            await this.getProducts();
          } else {
            await this.getPublicProducts();
          }
        })
        .then(() => {
          this.showLoadingMoreProducts = false;
        });
    },
    async getProductsByScrolling() {
      let ids = this.id.split("&");
      if (this.loggedIn && this.customerPortalToken != null) {
        let request = {
          header: {
            Authorization: this.token,
            "X-Merchant-Token": this.customerPortalToken,
          },
          payload: {
            branch_uuid: ids[0],
            brand_uuid: ids[1],
            product_name: this.searchKey,
          },
          page: this.nextPage,
        };
        if (!this.estoreIsLoading)
          await this.$store.dispatch("estore/getProducts", request); // do not fire while previous request is pending
      }
    },
    async getPublicProductsByScrolling() {
      let ids = this.id.split("&");
      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          branch_uuid: ids[0],
          brand_uuid: ids[1],
          product_name: this.searchKey,
        },
        page: this.nextPage,
      };
      if (!this.estoreIsLoading)
        await this.$store.dispatch("estore/getPublicProducts", request); // do not file while previous request is pending
    },
    async getSpecificBranchByScrolling() {
      let ids = this.id.split("&");

      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        is_public: !this.loggedIn,
        payload: {
          branch_uuid: ids[0],
        },
      };

      if (this.loggedIn) {
        request.header["Authorization"] = this.token;
      }

      if (this.loggedIn) {
        await this.getProductsByScrolling();
      } else {
        await this.getPublicProductsByScrolling();
      }
      this.$nextTick(() => {
        this.showLoadingMoreProducts = false;
      });
    },
    async showModal(uuid, isOpen) {
      this.outOfStock = false;
      if (isOpen) {
        this.$store.commit("estore/RESET_ERRORS");
        this.formattedAttributes = {};
        this.selectedVariations = {};
        this.variationProductTotal = "";
        let _this = this;
        if (this.loggedIn) {
          let request = {
            header: {
              Authorization: this.token,
              "X-Merchant-Token": this.customerPortalToken,
            },
            payload: {
              product_uuid: uuid,
              branch_uuid: this.specificBranch.uuid,
            },
          };
          await this.$store
            .dispatch("estore/getSpecificProduct", request)
            .then(async () => {
              if (this.estoreErrors == null) {
                _this.unlimitedStock = !_this.specificProduct.product_details.inventory[0].is_limited_stock
                _this.maxOrder = _this.specificProduct.product_details.inventory[0].stock;

                if (_this.specificProduct.product_details.type == 'simple') {
                  let inventory = _this.specificProduct.product_details.inventory;
                  if (inventory && inventory[0].is_limited_stock === 1) {
                    _this.outOfStock = (_this.specificProduct.product_details.inventory[0].stock == 0 || 
                      _this.specificProduct.product_details.inventory[0].stock == null
                    );
                  }
                }

                _this.formatSpecificProduct();
                _this.openModal();
              }
            });
        } else {
          let request = {
            header: {
              "X-Merchant-Token": this.customerPortalToken,
            },
            payload: {
              product_uuid: uuid,
              branch_uuid: this.specificBranch.uuid,
            },
          };
          await this.$store
            .dispatch("estore/getSpecificPublicProduct", request)
            .then(() => {
              if (this.estoreErrors == null) {
                _this.unlimitedStock = !_this.specificProduct.product_details.inventory[0].is_limited_stock
                _this.maxOrder = _this.specificProduct.product_details.inventory[0].stock;
                
                if (_this.specificProduct.product_details.type == 'simple') {
                  let inventory = _this.specificProduct.product_details.inventory;
                  if (inventory && inventory[0].is_limited_stock === 1) {
                    _this.outOfStock = (_this.specificProduct.product_details.inventory[0].stock == 0 || 
                        _this.specificProduct.product_details.inventory[0].stock == null
                    );
                  }
                }
                
                _this.formatSpecificProduct();
                _this.openModal();
              }
            });
        }
      }
    },
    openModal() {
      this.$refs["productModal"].show();
    },
    closeModal(origin = null) {
      this.remarks = "";
      this.isTitleVisible = false;
      switch (origin) {
        case "storeInfo":
          this.$refs["storeInfo"].hide();
          break;
        case "productModal":
          this.quantity = 1;
          this.$refs["productModal"].hide();
          break;
        default:
          break;
      }
    },
    addQuantity() {
      if (this.unlimitedStock) {
        this.quantity++;
      } else {
        if (this.quantity < this.maxOrder) this.quantity++;
      }
    },
    subtractQuantity() {
      if (this.quantity > 1)
        this.quantity--;
    },
    async addToCart() {
      let productType = this.specificProduct.product_details.type;
      let productName =
        this.specificProduct.product_details.name.toLowerCase();

      this.$store.commit("estore/RESET_ERRORS");

      if (productType == "simple") {
        let newQuantity;

        if (this.quantity <= 0) {
          alert("Minimum quantity should be 1.");
          return;
        } else {
          newQuantity = this.quantity;
        }

        let request = {
          header: {
            "X-Merchant-Token": this.customerPortalToken,
          },
          payload: {
            quantity: newQuantity,
            product_inventory_uuid:
              this.specificProduct.product_details.inventory[0].uuid,
            branch_uuid: this.specificBranch.uuid,
            branch_name: this.specificBranch.name,
            brand_uuid: this.specificBranch.brand_uuid,
            brand_name: this.specificBranch.brand_name,
            remarks: this.remarks,
            customer_lat: this.coordinates.lat,
            customer_lng: this.coordinates.long,
            add_on_uuids: Object.keys(this.addOns)
              .map((id) => {
                return this.addOns[`${id}`].map((item) => {
                  return item.split("|")[1];
                });
              })
              .flat(),
          },
        };
        this.remarks="";

        if (this.loggedIn) request.header["Authorization"] = this.token;
        else if (
          !this.loggedIn &&
          this.cartUuid
        ) request.payload["cart_uuid"] = this.cartUuid;
        
        let _this = this;
        await this.$store.dispatch("estore/addToCart", request).then(() => {
          if (this.estoreErrors == null) {
            _this.quantity = 1;

            if (_this.cartUuid && !_this.loggedIn)
              request.payload["cart_uuid"] = this.cartUuid;

            _this.$store.dispatch("estore/viewCart", request);
            _this.$store.commit("estore/SET_CART");
            _this.$refs["productModal"].hide();
          } else {
            this.$refs["stocksModal"].show();
          }
        });
      } else {
        let selectedVariations = this.selectedVariations[productName];

        let attributeNames = this.formattedAttributes[productName].map(
          (attribute) => attribute.name.toLowerCase()
        );

        let variationCode = "";
        for (let index = 0; index < attributeNames.length; index++) {
          const attributeName = attributeNames[index];
          if (selectedVariations[attributeName] !== "") {
            variationCode += "_" + selectedVariations[attributeName];
          } else {
            this.$store.commit("estore/SET_ERRORS", {
              errors: {
                [attributeName]: "Please choose a " + attributeName,
              },
            });
            break;
          }
        }
        let inventory = this.specificProduct.product_details.inventory.filter(
          (inventory) => inventory.variation_code === variationCode.substring(1)
        );

        if (inventory.length > 0 && this.estoreErrors == null) {
          let newQuantity;

          if (this.quantity <= 0) {
            alert("Minimum quantity should be 1.");
            return;
          } else {
            newQuantity = this.quantity;
          }

          let request = {
            header: {
              "X-Merchant-Token": this.customerPortalToken,
            },
            payload: {
              quantity: newQuantity,
              product_inventory_uuid: inventory[0].uuid,
              branch_uuid: this.specificBranch.uuid,
              branch_name: this.specificBranch.name,
              brand_uuid: this.specificBranch.brand_uuid,
              brand_name: this.specificBranch.brand_name,
              remarks: this.remarks,
              customer_lat: this.coordinates.lat,
              customer_lng: this.coordinates.long,
              add_on_uuids: Object.keys(this.addOns)
                .map((id) => {
                  return this.addOns[`${id}`].map((item) => {
                    return item.split("|")[1];
                  });
                })
                .flat(),
            },
          };
          this.remarks="";

          if (this.loggedIn) request.header["Authorization"] = this.token;
          else if (
            !this.loggedIn &&
            this.cartUuid
          ) request.payload["cart_uuid"] = this.cartUuid;
          
          let _this = this;
          await this.$store.dispatch("estore/addToCart", request).then(() => {
            if (this.estoreErrors == null) {
              _this.quantity = 1;

              if (_this.cartUuid && !_this.loggedIn)
                request.payload["cart_uuid"] = this.cartUuid;

              _this.$store.dispatch("estore/viewCart", request);
              _this.$store.commit("estore/SET_CART");
              _this.formattedAttributes = {};
              _this.selectedVariations = {};
              _this.variationProductTotal = "";
              _this.$refs["productModal"].hide();
            } else {
              this.$refs["stocksModal"].show();
            }
          });
        }
      }
    },
    formatSpecificProduct() {
      let specificProductName =
        this.specificProduct.product_details.name.toLowerCase();
      let specificProductAttributes =
        this.specificProduct.product_details.attributes;

      this.formattedAttributes[specificProductName] = [];
      this.selectedVariations[specificProductName] = {};
      specificProductAttributes.forEach((attribute) => {
        let attributeName = attribute.name.toLowerCase();
        this.formattedAttributes[specificProductName].push(attribute);
        this.selectedVariations[specificProductName][attributeName] = "";
      });
    },
    selectVariation(productName, attributeName, variationHash) {
      this.outOfStock = false;
      this.selectedVariations[productName][attributeName] = variationHash;
      let selectedVariations = this.selectedVariations[productName];

      let attributeNames = this.formattedAttributes[productName].map(
        (attribute) => attribute.name.toLowerCase()
      );

      let variationCode = "";
      for (const attributeName of attributeNames) {
        variationCode += "_" + selectedVariations[attributeName];
      }

      let inventory = this.specificProduct.product_details.inventory.filter(
        (inventory) => inventory.variation_code === variationCode.substring(1)
      );

      if (inventory.length > 0) {
        this.quantity = 1;
        if (inventory[0].is_limited_stock == 0) {
          this.unlimitedStock = true;
        } else {
          this.unlimitedStock = false;
          this.maxOrder = inventory[0].stock;

          if (inventory[0].stock == 0 || inventory[0].stock == null) {
            this.outOfStock = true;
          }
        }

        this.productIsUnavailable = false;
        if (inventory[0].on_sale) {
          this.variationProductTotal = inventory[0].sale_price;
          if (this.$moment(inventory[0].on_sale_to).isBefore(this.$moment())) {
            this.variationProductTotal = inventory[0].regular_price;
          } else {
            this.variationProductTotal = inventory[0].sale_price;
          }
        } else {
          this.variationProductTotal = inventory[0].regular_price;
        }
      } else {
        this.quantity = 1;
        let emptyAttributeNames = 0;
        for (const attributeName of attributeNames) {
          if (!selectedVariations[attributeName]) {
            emptyAttributeNames++;
          }
        }
        if (emptyAttributeNames == 0) {
          // Product is Unavailable
          this.productIsUnavailable = true;
        }
      }
    },
    async scrollTo(categoryId) {
      const div = `product-category-${categoryId}`;

      if (this.searchKey) await this.resetProducts();

      if (
        !this.products.some((product) => product.category_id === categoryId)
      ) {
        if (this.loggedIn) {
          let ids = this.id.split("&");
          if (this.loggedIn && this.customerPortalToken != null) {
            let request = {
              header: {
                Authorization: this.token,
                "X-Merchant-Token": this.customerPortalToken,
              },
              payload: {
                branch_uuid: ids[0],
                brand_uuid: ids[1],
                category_id: categoryId,
              },
              page: this.page,
            };
            await this.$store
              .dispatch("estore/getProductsByNavigation", request)
              .then(() => {
                this.showLoadingMoreProducts = false;
              })
              .then(() => {
                this.scrollAnimate(div);
              });
          }
        } else {
          let ids = this.id.split("&");
          let request = {
            header: {
              "X-Merchant-Token": this.customerPortalToken,
            },
            payload: {
              branch_uuid: ids[0],
              brand_uuid: ids[1],
              category_id: categoryId,
            },
            page: this.page,
          };
          await this.$store
            .dispatch("estore/getPublicProductsByNavigation", request)
            .then(() => {
              this.showLoadingMoreProducts = false;
            })
            .then(() => {
              this.scrollAnimate(div);
            });
        }
      } else {
        this.scrollAnimate(div);
      }
    },
    scrollAnimate(div) {
      $("html, body").animate({
        scrollTop: eval(
          $(`#${div.replace(/\s/g, "")}`).offset().top -
            $("#navbar-top-container").height() -
            $("#products-navigation").height()
        ),
      });
    },
    invalidFeedback(field) {
      if (this.estoreErrors == null) {
        return "";
      }
      return this.estoreErrors.errors[field];
    },
    state(field) {
      if (this.estoreErrors == null) {
        return false;
      }
      return this.estoreErrors.errors[field] ? false : true;
    },
    showStoreModal() {
      this.$refs["storeInfo"].show();
      Vue.$gmapDefaultResizeBus.$emit("resize");
    },
    refreshMap() {
      this.currentStyle = {
        width: "100%",
        height: "400px",
      };
      Vue.$gmapDefaultResizeBus.$emit("resize");
    },
    updateSelectedAddOns(limit, id) {
      // Selection Limit per Add-On Category
      this.$nextTick(() => {
        if (this.addOns[`${id}`].length > limit) {
          this.addOns[`${id}`].splice(0, 1);
        }
      });
    },
    initAddOns() {
      // Initial Value of addOns
      this.addOns = {};
      const obj = {};
      this.$nextTick(() => {
        this.specificProduct.product_details.add_on_category.map((category) => {
          obj[`${category.id}`] = [];
        });
        this.addOns = obj;
      });
    },
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getNavCategoryTopPosition() {
      const navbarTopContainerHeight = document.getElementById(
        "navbar-top-container"
      );
      return this.isMobile && navbarTopContainerHeight !== null
        ? `${navbarTopContainerHeight.clientHeight}px`
        : "0px";
    },
    isScrolledIntoView(el) {
      let rect = el.getBoundingClientRect();
      let elemTop = rect.top;
      let elemBottom = rect.bottom;

      let isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      return isVisible;
    },
    getNextProducts() {
      let scrolledTo = document.querySelector(".footer");
      if (
        scrolledTo &&
        this.isScrolledIntoView(scrolledTo) &&
        this.nextPage <= this.maxPage &&
        this.nextPage != 0 &&
        this.nextPage != null
      ) {
        this.showLoadingMoreProducts = true;
        if (!this.estoreIsLoading) this.getSpecificBranchByScrolling(); // do not file while previous request is pending
      }
    },
    async loadProducts() {
      this.$store.commit("estore/resetProductsAndPagination");

      if (this.loggedIn) await this.getProducts();
      else await this.getPublicProducts();

      $("html, body").animate({
        scrollTop: eval($("#products-navigation").offset().top),
      });
    },
    async resetProducts() {
      this.searchKey = "";
      await this.loadProducts();
    }
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    productUuid: {
      type: String,
      required: false,
    },
  },
  watch: {
    searchKey() {
      this.handleSearchKeyChange();
    },
  },
  mounted() {
    $("body").css({ backgroundColor: "#ffffff" });
    window.addEventListener("scroll", this.getNextProducts);

    this.$root.$on("bv::modal::shown", (event, id) => {
      if (id === "product_details") {
        const modal_body = document.querySelector(".modal-body");
        const product_title = document.getElementById("productNameDetails");
        const isInModalView = function (elem) {
          const bounding = elem.getBoundingClientRect();
          return bounding.top <= modal_body.offsetHeight + bounding.height * 2;
        };
        modal_body.addEventListener("scroll", () => {
          this.isTitleVisible = isInModalView(product_title);
        });
      }
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.getNextProducts);
  },
  filters: {
    formatCategoryNames(categories) {
      return categories && categories.length
        ? categories
            .map(({ name }) => name)
            .slice(0, 4)
            .join(", ")
        : "";
    },
    formatProductDescription(value) {
      return value
        ? _.truncate(value, {
            length: this.isMobile ? 45 : 55,
            separator: " ",
          })
        : "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "./../../assets/styles/views/store/_base.scss";
</style>

<style lang="scss">
#navigation a:hover {
  color: var(--color) !important;
}

#nav-for-category {
  z-index: 2 !important;
}

#navigation .btn-group {
  vertical-align: top;
}

#navigation .pill-category {
  background-color: #e9ebed !important;
  color: #2f3941 !important;
  font-size: 16px;
  margin-right: 1rem;
  &:last-child {
    margin-right: 0;
  }
  &.active {
    background-color: var(--color) !important;
    color: var(--button-text-color) !important;
  }
}
#other-categories {
  .other-categories-dropdown {
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    .other-categories-link {
      color: #2f3941;
      font-size: 16px;
      white-space: normal;
      &.active {
        background-color: var(--color);
        color: var(--button-text-color);
      }
      &:active {
        background-color: var(--color) !important;
        color: var(--button-text-color) !important;
      }
    }
  }
  .dropdown-toggle.other-categories-toggle {
    padding-right: 33px;
    &.active {
      background-color: var(--color) !important;
      color: var(--button-text-color) !important;
    }
    &::after {
      content: "";
      border: 0 !important;
      background: url("~@/assets/images/arrow-down.svg") no-repeat center;
      position: absolute;
      width: 17px;
      height: 8px;
      display: inline-block;
      bottom: 13px;
    }
  }
}
.addons-checkbox-group {
  & > .custom-checkbox {
    .custom-control-input ~ .custom-control-label {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.product-title-if-not-visible {
  transition: all ease 0.2s;
  h4 {
    font-size: 20px !important;
  }
}

.product-modal-close {
  z-index: 1;
  right: 0;
}

#product-carousel {
  max-height: 310px;
  overflow: hidden;
  .slick-track {
    display: flex;
  }
  .slick-dots {
    top: 280px;
    width: 100%;
    justify-content: center;
    list-style: none;
    padding: 0;
    button {
      color: transparent;
      margin: 0 5px;
      border: 0;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      outline: 0;
      padding: 0;
      background-color: #fff;
      &::before {
        display: none;
      }
    }
    .slick-active {
      button {
        background-color: var(--color) !important;
      }
    }
  }
}
</style>
